import React from 'react'
// import clsx from 'clsx'
import { withStyles } from '@mui/styles';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const StyledMenu = withStyles({
  paper: {
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.2)',
    border: 'none'
  },
  root: {
    marginTop: '8px',
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0
  }
})((props) => (
  <Menu
    getcontentanchorel={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    color: '#888',
    fontSize: 12,
    minWidth: 150,
    minHeight: 35,
    '&:hover': {
      // backgroundColor: theme.palette.primary.main,
      // color: theme.palette.common.white,
      // '& .MuiListItemIcon-root, & .MuiListItemText-primary, & .MuiListItem-root': {
      //   color: theme.palette.common.white,
      // },
    },
  },
  selected: {
    backgroundColor: theme.palette.primary.main + ' !important',
    color: 'white'
  }
}))(MenuItem);


export {StyledMenu, StyledMenuItem}